"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var core_1 = require("@bodiless/core");

var lodash_1 = require("lodash");

var useMenuOptions = function useMenuOptions(props) {
  var onAdd = props.onAdd,
      onDelete = props.onDelete,
      canDelete = props.canDelete;
  var menuOptions = react_1.useMemo(function () {
    return [{
      name: 'Add',
      icon: 'add',
      label: 'Add',
      handler: onAdd,
      global: false,
      local: true
    }, {
      name: 'Remove',
      icon: 'delete',
      label: 'Delete',
      isHidden: function isHidden() {
        return !canDelete();
      },
      handler: onDelete,
      global: false,
      local: true
    }];
  }, []);
  return menuOptions;
}; // TODO: Maybe generalize this as an "alterDesign()" method.


var asEditableList = function asEditableList(List) {
  return function (_a) {
    var design = _a.design,
        rest = __rest(_a, ["design"]);

    var _b = design || {},
        Title = _b.Title,
        ItemMenuOptionsProvider = _b.ItemMenuOptionsProvider;

    var newDesign = __assign(__assign({}, design || {}), {
      Title: lodash_1.flow(Title || lodash_1.identity, core_1.ifEditable(core_1.withContextActivator('onClick'), core_1.withLocalContextMenu), core_1.withoutProps(['onAdd', 'onDelete', 'canDelete']), ItemMenuOptionsProvider || lodash_1.identity, core_1.ifEditable(core_1.withMenuOptions({
        useMenuOptions: useMenuOptions,
        name: 'list-item'
      })))
    });

    return react_1.default.createElement(List, __assign({
      design: newDesign
    }, rest));
  };
};

exports.default = asEditableList;